import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MentorshipModalComponent } from './mentorship-modal.component';

@NgModule({
  declarations: [MentorshipModalComponent],
  exports: [MentorshipModalComponent],
  imports: [CommonModule],
})
export class MentorshipModalModule {}
